<template>
  <div>
    <div>
      <el-form class="page-actions">
        <el-select v-model="formData.queryType" placeholder="请选择用户类型">
          <el-option
            v-for="item in typeTwo"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          clearable
          v-model="formData.queryValue"
        ></el-input>
        <span>交易对：</span>
        <el-select v-model="formData.pair" placeholder="请选择交易对">
          <el-option
            v-for="item in coinList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入订单号"
          clearable
          v-model="formData.orderId"
          v-show="formData.orderType === '1'"
        >
        </el-input>
        <el-select v-model="formData.orderType" placeholder="订单类型">
          <el-option
            v-for="item in orderTwo"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="formData.startTime"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          v-show="formData.orderType === '1'"
        >
        </el-date-picker>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入你要排除的用户ID，用;隔开"
          v-model="formData.orderExclude"
          v-show="formData.orderType === '1'"
        >
        </el-input>
        <el-select
          v-model="formData.orderStatus"
          placeholder="订单状态"
          v-show="formData.orderType === '1'"
        >
          <el-option
            v-for="item in ordertypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
        <el-button
          type="primary"
          @click="handRefresh({ page: 1 })"
          v-show="formData.orderType === '0'"
          :loading="loading"
          >刷新</el-button
        >
        <a :href="downloadLink" target="_blank">导出Excel</a>
        <a :href="downloadLinks" target="_blank">导出所有Excel</a>
      </el-form>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="id" label="订单号" width="200"></el-table-column>
      <el-table-column label="委托时间">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="pair" label="交易对"></el-table-column>
      <el-table-column prop="direction" label="委托类型">
        <template slot-scope="scope">
          <span v-if="scope.row.direction == 'ASK'">卖出</span>
          <span v-else-if="scope.row.direction == 'BID'">买入</span>
        </template>
      </el-table-column>
      <el-table-column prop="leverType" label="交易类型">
        <template slot-scope="scope">
          <span v-if="scope.row.leverType == 'PHYSICAL'">币币交易</span>
          <span v-else-if="scope.row.leverType == 'ISOLATED'">杠杆交易</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未成交</span>
          <span v-else-if="scope.row.status == 1">部分成交</span>
          <span v-else-if="scope.row.status == 8">已完成</span>
          <span v-else-if="scope.row.status == 9">已撤单</span>
          <span v-else-if="scope.row.status == 10">系统错误</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总数量"></el-table-column>
      <el-table-column prop="dealAmount" label="成交数量"></el-table-column>
      <el-table-column prop="price" label="单价"></el-table-column>
      <el-table-column prop="dealAvgPrice" label="成交均价"></el-table-column>
      <el-table-column
        prop="frozenAmountByOrder"
        label="冻结数量"
      ></el-table-column>
      <el-table-column
        prop="totalAnchorCoin"
        label="成交总额"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="handleExecuteRecord(scope.row.id, scope.row.direction)"
            v-if="scope.row.status < 5"
            >撤单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="search"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'order',
  data() {
    return {
      loading: false,
      formData: {
        startTime: '',
        queryType: '0',
        queryValue: '',
        orderId: '',
        orderType: '0',
        orderExclude: '',
        orderStatus: '',
        pair: ''
      },
      typeTwo: [
        { value: '0', label: '用户ID' }
        // { value: '1', label: '用户账号' }
      ],
      orderTwo: [
        { value: '0', label: '当前委托' },
        { value: '1', label: '历史委托' }
      ],
      ordertypes: [
        { value: '0', label: '未完成' },
        { value: '1', label: '部分成交' },
        { value: '8', label: '已完成' },
        { value: '9', label: '已撤单' }
      ]
    };
  },

  computed: {
    ...mapState('order', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList'
    ]),
    downloadLink() {
      const data = {
        ...this.formData,
        ...this.pagination,
        status: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/view/order?${params}`;
    },
    downloadLinks() {
      return `/la/admin/produce/excel/all`;
    }
  },
  methods: {
    ...mapActions('order', ['list', 'cancel', 'refresh']),
    search(data = {}) {
      if (!this.formData.queryValue) {
        this.$message.error('请输入用户ID');
        return;
      }
      if (!this.formData.pair) {
        this.$message.error('请选择交易对');
        return;
      }
      this.list({ ...this.formData, ...this.pagination, ...data });
    },
    handleExecuteRecord(id, direction) {
      this.$confirm('确定要进行撤单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.cancel({
          pair: this.formData.pair,
          orderNo: id,
          direction: direction,
          uid: this.formData.queryValue
        }).then(() => {
          this.$message.success('操作成功！');
          this.search();
        });
      });
    },
    handRefresh(data = {}) {
      if (!this.formData.pair) {
        this.$message.error('请选择交易对');
        return;
      }
      this.loading = true;
      this.refresh({ pair: this.formData.pair })
        .then(() => {
          this.$message.success('刷新成功');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {
    Pagination
  },
  mounted() {
    // this.search();
  }
};
</script>

<style lang="less" scoped>
.el-textarea {
  width: auto;
}
</style>
